import { useCallback, useState } from 'react';

import { LoaderCircle, OctagonPause } from 'lucide-react';
import { LoadingSpinner, DefaultTooltip, Button } from 'twyne-new.ui'

import ConfirmationPopover from '@/components/ConfirmationPopover';
import { useGrid } from '@Components/Grid';
import { getInfo, keyOf } from '@Components/Grid/components/Table/formatters';

export default function CancelFormatter({ info }) {
  const { events: { handleCancel } } = useGrid()

  const [canceling, setCanceling] = useState(false)

  const { row } = getInfo(info)
  const { id, meta: { cancelProcess } } = row
  const targetId = keyOf(info, 'download')

  const handleClick = useCallback(async () => {
    setCanceling(true)
    await handleCancel(id)
    setCanceling(false)
  }, [handleCancel, id])

  if (canceling || cancelProcess) {
    return <>
      <DefaultTooltip content='Canceling' side='left'>
        <span id={`canceling-${id}`} className="action">
          <LoaderCircle size='16' className='animate-spin' />
        </span>
      </DefaultTooltip>
    </>
  }

  return <>
    <ConfirmationPopover title="Cancel Data Extractor"
      target={<>
        <DefaultTooltip content='Cancel' side='left'>
          <span id={targetId} className="action">
            {canceling ? <LoadingSpinner width={16} height={16} /> : <OctagonPause size={16} />}
          </span>
        </DefaultTooltip>
      </>}>
      <p className='mb-2 font-bold'>Are you sure you want do this?</p>
      <Button color="danger" onClick={() => handleClick()} block>Yes, I am sure</Button>
    </ConfirmationPopover>
  </>
}
